// Increment this number before each commit/checkpoint
export const APP_VERSION = "1.3.2";
